import { createFileRoute } from "@tanstack/react-router";
import AdminContentPage from "@/pages/admin/content";

export const Route = createFileRoute("/app/admin/content")({
  component: AdminContentPage,
});
